import { put, call } from 'redux-saga/effects';
import userServices from '../services/userServices';
import ActionTypes from '../actions/types';
import mediaServices from '../services/mediaServices';

function* registerSaga(request) {
  console.log('registerSaga(): ', request);
  try {
    const response = yield call(userServices.register, request);
    yield put({ type: ActionTypes.REGISTER_SUCCESS, response });
  } catch (error) {
    yield put({ type: ActionTypes.REGISTER_FAIL, error });
  }
}

function* loginSaga(request) {
  console.log('loginSaga(): ', request);
  try {
    const response = yield call(userServices.login, request);
    yield put({ type: ActionTypes.LOGIN_SUCCESS, response });
    console.log('loginSaga() success: ', response);
  } catch (error) {
    yield put({ type: ActionTypes.LOGIN_FAIL, error });
    console.log('loginSaga() error: ', error);
  }
}

function* logoutSaga() {
  try {
    const response = yield call(userServices.logout);
    yield put({ type: ActionTypes.LOGOUT_SUCCESS, response });
  } catch (error) {
    yield put({ type: ActionTypes.LOGOUT_FAIL, error });
  }
}

function* updateUserSaga(request) {
  console.log('updateUserSaga(): ', request);
  try {
    const response = yield call(userServices.updateUser, request);
    yield put({ type: ActionTypes.USER_UPDATE_SUCCESS, response });
    console.log('updateUserSaga() success: ', response);
  } catch (error) {
    yield put({ type: ActionTypes.USER_UPDATE_FAIL, error });
    console.log('updateUserSaga() error: ', error);
  }
}

function* updateUserImgSaga(request) {
  console.log('updateUserImgSaga(): ', request);
  try {
    const imgURL = yield call(mediaServices.uploadProfileImg, request);
    request.payload.attributes = { picture: imgURL };
    const response = yield call(userServices.updateUserPicture, request);
    yield put({ type: ActionTypes.USER_UPDATE_IMG_SUCCESS, response });
    console.log('updateUserImgSaga() success: ', response);
  } catch (error) {
    yield put({ type: ActionTypes.USER_UPDATE_IMG_FAIL, error });
    console.log('updateUserImgSaga() error: ', error);
  }
}

const userSagas = {
  registerSaga,
  loginSaga,
  logoutSaga,
  updateUserSaga,
  updateUserImgSaga,
};

export default userSagas;
